import { NetworkQualityScore } from '@yandex-video-platform/goloom-sdk';

import { NetworkQualityType } from '../constants';

const BAD_QUALITY_SCORES = new Set([NetworkQualityScore.POOR, NetworkQualityScore.GOOD]);

export const getNetworkQualityTypeByScore = (score: NetworkQualityScore): NetworkQualityType =>
    BAD_QUALITY_SCORES.has(score) ? NetworkQualityType.BAD : NetworkQualityType.GOOD;
